// Native
import { useState } from "react"

// Components
import { AlertDialogBody, AlertDialogFooter, Button, ButtonGroup, Divider, Stack, useDisclosure, useToast } from "@chakra-ui/react"
import { Dash, Dialog, Form, Label } from "components"

// Config
import { Moment, API } from "config"

// Screens
import { Authenticate } from "screens"

export default function AlertBlock({ data, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ blocked_reason, setReason ] = useState()
    const [ loading, setLoading ] = useState(false)
    const auth = useDisclosure()

    // Bloqueia o usuário
    const onBlock = async () => {
        setLoading(true)

        try{
            await API.put(`/customers/${data?.customer?.id}/block`, {blocked_reason})
            toast({ title: 'O cliente foi bloqueado.', status: 'info' })
            onSuccess()
            props.onClose()
        }catch(err){
            toast({ title: 'Não foi possível bloquear o cliente.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    // Desbloqueia o usuário
    const onUnblock = async () => {
        setLoading(true)

        try{
            await API.put(`/customers/${data?.customer?.id}/unblock`)
            toast({ title: 'O cliente foi desbloqueado.', status: 'info' })
            onSuccess()
            props.onClose()
        }catch(err){
            toast({ title: 'Não foi possível desbloquear o cliente.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    // Caso já esteja bloqueado, exibe a tela de desbloqueio
    if(!!data?.customer?.blocked_at){
        return(
        <>
            <Dialog title={`Desbloquear cadastro de ${data?.customer?.name}?`} loading={loading} {...props}>
                <AlertDialogBody>
                    Este cadastro no momento encontra-se bloqueado no sistema. Você deseja reverter o bloqueio e liberar os acessos do cliente?
                    <Divider my={4} />
                    <Stack>
                        <Label label="Data do bloqueio:" children={Moment(data?.customer?.blocked_at).format('LLL')} />
                        <Label label="Motivo do bloqueio:" children={<Dash children={data?.customer?.blocked_reason} />} />
                    </Stack>
                </AlertDialogBody>
                <AlertDialogFooter>
                    <ButtonGroup size="sm" isDisabled={loading}>
                        <Button isLoading={loading} children="Desbloquear" onClick={auth.onOpen} />
                        <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
                    </ButtonGroup>
                </AlertDialogFooter>
            </Dialog>

            <Authenticate {...auth} onSuccess={onUnblock} />
        </>
        )
    }

    // Caso não esteja bloqueado, exibe a tela de bloqueio
    return(
        <>
            <Dialog title={`Bloquear cadastro de ${data?.customer?.name}?`} loading={loading} {...props}>
                <AlertDialogBody>
                    Ao bloquear o cadastro, o cliente será desconectado de todas as sessões logadas e será impedido de acessar os sistemas de núcleo e consultor novamente até o desbloqueio.
                    <Divider my={4} />
                    <Form.Textarea 
                        label="Motivo do bloqueio:"
                        placeholder="Por favor, detalhe o motivo de o consultor está sendo bloqueado."
                        helper="Esta mensagem é apenas para fins administrativos e não será exibida para o consultor."
                        onChange={e => setReason(e?.target?.value)}
                        value={blocked_reason}
                        isDisabled={loading}
                    />
                </AlertDialogBody>
                <AlertDialogFooter>
                    <ButtonGroup size="sm" isDisabled={loading}>
                        <Button isLoading={loading} children="Bloquear" onClick={auth.onOpen} />
                        <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
                    </ButtonGroup>
                </AlertDialogFooter>
            </Dialog>

            <Authenticate {...auth} onSuccess={onBlock} />
        </>
    )
}